// SPDX-License-Identifier: AGPL-3.0-or-later

import {useCoretProfileCosmetics} from '@app/features/coret/CoretProfileCosmetics';
import styles from '@app/features/coret/CoretProfileSocialActivity.module.css';
import Users from '@app/features/user/state/Users';
import {GiftIcon, HeartIcon, StarIcon} from '@phosphor-icons/react';

const ACTIVITY_LABELS = {
	gift: 'Recebeu um presente',
	recognition: 'Recebeu reconhecimento social',
	compliment: 'Recebeu um elogio',
	friendship_card: 'Recebeu um cartão de amizade',
} as const;

export function CoretProfileSocialActivity({userId}: {userId: string}) {
	const cosmetics = useCoretProfileCosmetics(userId);
	if (Users.currentUser?.id === userId || !cosmetics?.social_activity?.length) return null;

	return (
		<section className={styles.section} aria-labelledby="coret-social-activity-title">
			<div className={styles.heading}>
				<HeartIcon weight="fill" />
				<div>
					<strong id="coret-social-activity-title">Atividade social</strong>
					<span>Presentes e reconhecimentos recebidos recentemente</span>
				</div>
			</div>
			<div className={styles.list}>
				{cosmetics.social_activity.map((entry) => (
					<article key={entry.id} className={styles.item}>
						<div className={styles.icon}>
							{entry.type === 'gift' ? (
								<GiftIcon weight="fill" />
							) : entry.type === 'recognition' ? (
								<HeartIcon weight="fill" />
							) : (
								<StarIcon weight="fill" />
							)}
						</div>
						<div>
							<strong>{ACTIVITY_LABELS[entry.type]}</strong>
							{entry.message ? <p>{entry.message}</p> : null}
							<span>
								{entry.amount ? `${entry.amount} Coins · ` : ''}
								{new Date(entry.created_at).toLocaleDateString()}
							</span>
						</div>
					</article>
				))}
			</div>
		</section>
	);
}
